module.exports = __webpack_public_path__ + "img/icon_T_And_C.e9cfc3fd.jpg";